intra_module.factory('CurrentActivities', function($resource, api_url, modules_url) {
    const url    = `${api_url}/students/:login`;
    const params =
        {login: '@login'};

    const actions = {
        getFreeSlots: {
            method:  'GET',
            isArray: true,
            url:     `${url}/getFreeSlots`
        },
        query: {
            method:  'GET',
            isArray: false,
            url:     `${modules_url}/students/:login/currentactivities`
        }
    };

    return $resource(url, params, actions);
});
